module.exports = __webpack_public_path__ + "img/settings.11de4028.svg";